// extracted by mini-css-extract-plugin
export default {"text_container":"GameMode_text_container__IDq7k","back_btn":"GameMode_back_btn__Xc7Mh","back_icon":"GameMode_back_icon__y87if","text":"GameMode_text__PxG8n"};